import React from 'react'

function SignUp() {
  return (
    <h1>SignUp</h1>
  )
}

export default SignUp